import React from 'react'
import { observer } from 'mobx-react'
import InventoryItemForm from '../../components/InventoryItemForm'
import CreateInventoryItemViewModel from './CreateInventoryItemViewModel'

interface Props {
  vm: CreateInventoryItemViewModel
}

function CreateInventoryItemDialog({ vm }: Props) {
  return (
    <InventoryItemForm
      vm={vm}
      title="Add global service item"
      submitText="Add new"
    />
  )
}

export default observer(CreateInventoryItemDialog)
